import { createRouter, createWebHistory } from 'vue-router'
import frontendRoutes from './frontend'
import userRoutes from './user'
import vendorRoutes from './vendor'
import { getAuthRole, isAuthenticated } from '@/services/auth'

const routes = [
    ...frontendRoutes,
    ...userRoutes,
    ...vendorRoutes,
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('@/views/frontend/NotFound.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, top: 96 }
    return { top: 0 }
  }
})

const publicAuthRedirectNames = new Set(['login', 'forgot-password', 'vendor-signup'])
const getRoleHome = (role) => String(role || '').toLowerCase() === 'vendor' ? '/dashboard' : '/host'

router.beforeEach((to, from, next) => {
  const authenticated = isAuthenticated()
  const authRole = getAuthRole()

  if (authenticated && publicAuthRedirectNames.has(to.name)) {
    next({ path: getRoleHome(authRole) })
    return
  }

  if (to.meta.requiresAuth && !authenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }
  const allowedRole = to.meta.allowedRole
  if (allowedRole && authRole && allowedRole !== authRole) {
    next({ path: getRoleHome(authRole) })
    return
  }
  next()
})

export default router
